import React, { Component, useState, useEffect, forwardRef } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import makeSelectPostAnnounceFormVendorScreen from './selector';
import reducer from './reducer';
import saga from './saga';

import {
  AspectRatio,
  Icon,
  HStack, 
  Avatar, 
  Heading, 
  FormControl,
  Input,
  TextArea,
  VStack, 
  Box, 
  Center,
  Text,
  Image, 
  Flex,
  ScrollView, 
  Button,
  CheckIcon,
  Select,
  Stack,
  Menu,
  Pressable,
  Fab} from 'native-base';
import {FaInfoCircle, FaUserCircle} from 'react-icons/fa';
import { ContainerPage } from '../../components/ContainerPage';
import { commonStyle } from '../../styles';
import { defaultAction, delSavedDetail, getPegawai, getPengumuman, setSavedDetail, submitCallVendor, submitPegawai, submitPengumuman, updateInput } from './actions';
import api from '../../util/api';
import helper from '../../util/helper';
import { MdCalendarToday, MdDelete, MdFileCopy, MdModeEdit, MdMoreVert, MdRemoveRedEye } from 'react-icons/md';
import DatePicker from "react-datepicker";
import moment from 'moment';
import { Accordion, AccordionItem } from '@szhsin/react-accordion';
import BadgeStatus from '../../components/BadgeStatus';
import ImageSlider from '../../components/ImageSlider';
import { AiOutlinePlus } from 'react-icons/ai';
import history from '../../util/history';
import MyAlertDialog from '../../components/MyAlertDialog';
import MyAlert from '../../components/MyAlert';
import LoadingOverlay from 'react-loading-overlay';
import makeSelectGlobalVar from '../../util/selector';
import MySelect2 from '../../components/MySelect2';

export function PostAnnounceFormVendorScreen({
  dispatch,
  location,
  postAnnounceFormVendorScreen,
  globalVar,
  onUpdateInput,
  onGetPengumuman,
  onSubmitCallVendor,
  onSetDetail,
  onDelDetail
}){
  const {id_pengumuman, viewOnly, new_data} = location.state;
  const[userData, setUserData] = useState();
  const [screenAccess, setScreenAccess] = useState([]);
  const [isOpenDialog, setOpenDialog] = useState(false);
  const [isOpenDialogSubmit, setOpenDialogSubmit] = useState(false);
  const[idxDetail, setIdxDetail] = useState();

  const imageList = [
    {path: '../../images/pintu.jpg'},
    {path: '../../images/pintu.jpg'},
    {path: '../../images/pintu.jpg'},
  ];

  useEffect(() => {
    const menus = api.getUserPrivileges();
    const allAccess = helper.generatePrivileges(menus);
    setScreenAccess(allAccess);
    // reset params
    dispatch(defaultAction());
    
    onUpdateInput('id_pengumuman_req_header', id_pengumuman);
  },[]);

  const InputDate = forwardRef(({ value, onClick }, ref) => (
    <Input 
      value={moment(postAnnounceFormVendorScreen.tgl_penugasan).format("DD/MM/YYYY")} 
      isReadOnly="true"
      onFocus={onClick} 
      borderRadius="lg" 
      variant="filled"
      ref={ref} 
      borderColor="primary.900" 
      InputRightElement={<Icon as={<Box><MdCalendarToday/></Box>} size={5} mr="2" color="muted.400" />} 
      />
  ));

  const InputDateExp = forwardRef(({ value, onClick }, ref) => (
    <Input 
      value={moment(postAnnounceFormVendorScreen.expired_date).format("DD/MM/YYYY HH:mm")} 
      isReadOnly="true"
      onFocus={onClick} 
      borderRadius="lg" 
      variant="filled"
      ref={ref} 
      borderColor="primary.900" 
      InputRightElement={<Icon as={<Box><MdCalendarToday/></Box>} size={5} mr="2" color="muted.400" />} 
      />
  ));

  const onChangeDt = (name_field, selectedDate) => {
    const currentDate = selectedDate;
    onUpdateInput(name_field, currentDate);
  };

  const handleSubmit = () => {
    setOpenDialogSubmit(false);
    
    const check_param = {
      tgl_penugasan: postAnnounceFormVendorScreen.tgl_penugasan,
      id_vendor: postAnnounceFormVendorScreen.id_vendor,
      id_pegawai: postAnnounceFormVendorScreen.id_pegawai
    };

    const isAllFilled = (obj) => {
        return Object.values(obj).every(value => value !== "" && value !== null && value !== undefined);
    };
    
    if (!isAllFilled(check_param)) {
        helper.warningToast('Mohon lengkapi semua data!');
        return;
    }

    onSubmitCallVendor();
  }

  const handleOnDeleteDetail = (idx) => {
    console.log('idx-detail:', idx);
    setIdxDetail(idx);
    setOpenDialog(true);
  }

  const handleDoDeleteDetail = () => {
    onDelDetail(idxDetail);
    setOpenDialog(false);
  }

  const handleGotDetail = (act, params) => {
    onSetDetail();
    history.push('post-announce-form-detail', params);
  }

  return (
        <ContainerPage options={{statusBar: true, prevPage: 'post-announce', title: 'Kirim Pengumuman'}}>
          <ScrollView showsHorizontalScrollIndicator={false} showsVerticalScrollIndicator={false}>
          <LoadingOverlay
                active={postAnnounceFormVendorScreen.loading}
                spinner
                text='Loading...'
                >
            <Flex>
              {/* <Box mt={4}>
                <Flex flexDirection="row" justifyContent="center" alignItems="center">
                  <Box shadow={3} borderColor="amber.100" borderRadius={20}>
                    <Image source={{
      uri: "https://images.unsplash.com/photo-1603415526960-f7e0328c63b1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
    }} borderRadius={20} alt='Room' size="lg"  />
                  </Box>
                  <Box ml={3}>
                    <Button variant="outline" colorScheme="primary" leftIcon={<Icon as={MaterialIcons} name="add-a-photo" size="sm" />}>Ganti Foto Profil</Button>
                  </Box>
                </Flex>
              </Box> */}
              <Box mx={3} my={5} p={4} backgroundColor="white" shadow={3} borderRadius="lg">
                <HStack space={2}>
                  <Icon as={<Box><FaInfoCircle/></Box>} size="5" mt="0.5" color="muted.400" />
                  <Text color="darkText" fontSize="md">
                    Form Hubungi Vendor
                  </Text>
                </HStack>
                <Box>
                  <VStack space={2} mt={2}>
                    <Box>
                        <FormControl mb="1" isRequired>
                          <FormControl.Label>Tanggal Pengambilan</FormControl.Label>
                          <DatePicker customInput={<InputDate/>} portalId='root-portal' className='input-datepicker' popperClassName='pooper-datepicker' selected={postAnnounceFormVendorScreen.tgl_penugasan} onChange={(date) => onChangeDt('tgl_penugasan', date)} />
                        </FormControl>
                    </Box>
                    <Box>
                    <FormControl mb="1" isRequired>
                          <FormControl.Label>Vendor</FormControl.Label>
                          {globalVar.list_vendor && 
                              <MySelect2
                                key="opt-unit"
                                isClearable
                                defaultValue="0"
                                placeholder="Pilih Vendor"
                                menuPortalTarget={document.body}
                                getOptionLabel={option => `${option.nama}`}
                                getOptionValue={option => option.id}
                                options={globalVar.list_vendor}
                                value={globalVar.list_vendor.filter(({id}) => id === postAnnounceFormVendorScreen.id_vendor)}
                                onChange={(selectedOption) => onUpdateInput('id_vendor',(selectedOption==null) ? 0 : selectedOption.id)}
                              />
                            }
                        </FormControl>
                    </Box>
                    <Box>
                      <FormControl mb="1" isRequired>
                          <FormControl.Label>Petugas Lapangan Pendamping</FormControl.Label>
                          {globalVar.list_pegawai && 
                          <MySelect2
                            key="opt-gedung"
                            isClearable
                            defaultValue="0"
                            placeholder="Pilih Pegawai"
                            menuPortalTarget={document.body}
                            getOptionLabel={option => `${option.name_employee}`}
                            getOptionValue={option => option.id}
                            options={globalVar.list_pegawai}
                            value={globalVar.list_pegawai.filter(({id}) => id === postAnnounceFormVendorScreen.id_pegawai)}
                            onChange={(selectedOption) => onUpdateInput('id_pegawai',(selectedOption==null) ? 0 : selectedOption.id)}
                          />
                          }
                        </FormControl>
                    </Box>
                  </VStack>
                </Box>
              </Box>
              {!viewOnly &&
              <HStack justifyContent="space-around" mb="32">
                  <Button w="1/3" isLoading={postAnnounceFormVendorScreen.loading} spinnerPlacement="end" isLoadingText="Submitting..." colorScheme="primary" onPress={() => setOpenDialogSubmit(true)}>Hubungi Vendor</Button>
                  <Button variant="link" onPress={() =>  history.replace('post-announce')} colorScheme="primary">Cancel</Button>
              </HStack>
              }
            </Flex>
            </LoadingOverlay>
          </ScrollView>

          <MyAlertDialog 
            alertTitle="Detail Permintaan" 
            alertDesc={`Apakah anda ingin menghapus permintaan ini ?`}
            alertNoLabel="Tidak"
            alertYesLabel="Hapus"
            colorScheme="danger"
            alertIsOpen={isOpenDialog}
            alertOnClose={() => setOpenDialog(false)}
            alertOnConfirm={() => handleDoDeleteDetail()}
          />

          <MyAlertDialog 
            alertTitle="Kirim Pengumuman" 
            alertDesc={`Apakah data sudah benar ?`}
            alertNoLabel="Tidak"
            alertYesLabel="Kirim"
            colorScheme="success"
            alertIsOpen={isOpenDialogSubmit}
            alertOnClose={() => setOpenDialogSubmit(false)}
            alertOnConfirm={() => handleSubmit()}
          />

          {/* {(screenAccess.includes("8:ADD") && !viewOnly) &&
            <Fab onPress={() => handleGotDetail('add','')} renderInPortal={false} shadow={2} size="lg" icon={<Icon color="white" as={<Box><AiOutlinePlus/></Box>} size="lg" />} />
          } */}
        </ContainerPage>
      );
    
}

const styles = {
  errorTextStyle: {
    color: 'red',
    fontStyle: 'italic',
    fontWeight: 'bold',
    alignSelf: 'center'
  }
};

const mapStateToProps = createStructuredSelector({
  postAnnounceFormVendorScreen: makeSelectPostAnnounceFormVendorScreen(),
  globalVar: makeSelectGlobalVar(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onUpdateInput: (name, value) => dispatch(updateInput({ name, value })),
    onGetPengumuman: id => dispatch(getPengumuman(id)),
    onSubmitCallVendor: () => dispatch(submitCallVendor()),
    onSetDetail: () => dispatch(setSavedDetail()),
    onDelDetail: idx => dispatch(delSavedDetail(idx)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect
)(PostAnnounceFormVendorScreen);